import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useLayoutEffect, useImperativeHandle, forwardRef } from 'react';
import autosize from 'autosize';
import { useStyles, StylesProvider, StyleSheet, padding } from '@rexlabs/styling';
import TextInput from './text-input';
var defaultStyles = StyleSheet({
  textArea: {
    minHeight: function minHeight(_ref) {
      var token = _ref.token;
      return token('textArea.minHeight', '8rem');
    },
    maxHeight: function maxHeight(_ref2) {
      var token = _ref2.token;
      return token('textArea.maxHeight', '80rem');
    },
    resize: function resize(_ref3) {
      var token = _ref3.token;
      return token('textArea.resize', 'vertical');
    }
  }
});

function TextAreaInput(_ref4) {
  var style = _ref4.style,
      className = _ref4.className,
      ref = _ref4.ref,
      _ref4$autoResize = _ref4.autoResize,
      autoResize = _ref4$autoResize === void 0 ? true : _ref4$autoResize,
      props = _objectWithoutProperties(_ref4, ["style", "className", "ref", "autoResize"]);

  var s = useStyles(defaultStyles, 'TextAreaInput');
  var textAreaRef = useRef(null);
  useLayoutEffect(function () {
    if (autoResize && textAreaRef.current) {
      autosize(textAreaRef.current);
    }
  }, [autoResize]);
  useImperativeHandle(ref, function () {
    return textAreaRef.current;
  }, []);
  return /*#__PURE__*/React.createElement("textarea", _extends({}, s.with('textArea')({
    style: style,
    className: className
  }), props, {
    ref: textAreaRef
  }));
}

var tokens = {
  textInput: _objectSpread(_objectSpread({
    height: 'auto'
  }, padding.tokens({
    target: 'textArea',
    // Spacing for the outer container
    // so that the drag handle is not
    // flush with the border
    all: 'xxxs'
  })), {}, {
    input: _objectSpread({}, padding.tokens({
      target: 'textArea.input',
      // Calculate spacing so that the total
      // spacing from the container border
      // to the text is 'spacing.xs`
      all: function all(_ref5) {
        var _context;

        var token = _ref5.token;
        return _concatInstanceProperty(_context = "calc(".concat(token('spacing.xs'), " - ")).call(_context, token('spacing.xxxs'), ")");
      }
    }))
  })
};
var displayName = 'TextArea';
export var TextArea = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    ref: ref,
    prefix: null,
    suffix: null,
    Prefix: null,
    Suffix: null
  }), TextAreaInput));
});
TextArea.displayName = displayName;
export default TextArea;